import React from "react";
import { Row, Col } from "reactstrap";
import InProgressManHoursChart from "./inProgress/InProgressManHoursChart";
import JobDetailsSummary from "./JobDetailsSummary";
import DetailingSummary from "./inProgress/DetailingSummary";
import ProjectDetailsSummary from "./inProgress/ProjectDetailsSummary";
import ProgrammingSummary from "./inProgress/ProgrammingSummary";
import PreProductionSummary from "./inProgress/PreProductionSummary";

const InProgressContent = () => {
  return (
    <>
      <Row>
        <Col sm="12">
          <InProgressManHoursChart />
        </Col>
      </Row>
      <Row className="my-3">
        <Col sm="4">
          <JobDetailsSummary />
        </Col>
        <Col sm="4" className="p-0"></Col>
        <Col sm="4">
          <ProjectDetailsSummary />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col sm="4">
          <DetailingSummary />
        </Col>
        <Col sm="4" className="p-0">
          <PreProductionSummary />
        </Col>
        <Col sm="4">
          <ProgrammingSummary />
        </Col>
      </Row>
    </>
  );
};

export default InProgressContent;
